import React, { Fragment, useState } from 'react';
import Checkbox from 'components/atoms/Checkbox/Checkbox';
import FormControl from 'components/atoms/FormControl/FormControl';
import FormLabel from 'components/atoms/FormLabel/FormLabel';
import FormGroup from 'components/atoms/FormGroup/FormGroup';
import FormControlLabel from 'components/atoms/FormControlLabel/FormControlLabel';

export default function CheckboxGroup(props) {
  const { formLabel, onSelectionChange, ...rest } = props;
  let items = props.items;

  const handleOnChange = (event) => {
    const itemsUpdated = items.map((item) =>
      item.name === event.target.name
        ? { ...item, checked: event.target.checked }
        : item
    );

    onSelectionChange(itemsUpdated);
  };

  return (
    <Fragment>
      <FormControl component="fieldset">
        <FormLabel>{formLabel}</FormLabel>
        <FormGroup row={true}>
          {items &&
            items.map((item, index) => {
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={item.checked}
                      name={item.name}
                      onChange={handleOnChange}
                    />
                  }
                  label={item.label}
                />
              );
            })}
        </FormGroup>
      </FormControl>
    </Fragment>
  );
}
